import { Component, Input } from '@angular/core';

import { CallbackResult, CallbackResultStatus, trackByIdx } from '../../../../../../../../utils';
import { CustomCustomerField } from '../../../../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomCustomerFieldType } from '../../../../../../../../models/organization-config-enums';


@Component({
  selector: 'app-add-custom-customer-field-modal',
  templateUrl: './add-custom-customer-field-modal.component.html',
  styleUrls: ['./add-custom-customer-field-modal.component.css']
})
export class AddCustomCustomerFieldModalComponent {
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public field: CustomCustomerField = {
    id: null,
    url: null,
    name: '',
    field_type: CustomCustomerFieldType.checkboxes,
    options: [''],
    created_at: null,
    updated_at: null
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  public CustomCustomerFieldType = CustomCustomerFieldType;
  public trackByIdx = trackByIdx;

  constructor(
    public activeModal: NgbActiveModal,
    private orgConfigService: OrganizationConfigService
  ) {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.orgConfigService
      .addCustomCustomerField(this.field)
      .then(createdField => {
        let successText = 'Field created successfully.';
        if (createdField.name && createdField.name.length > 0) {
          successText = createdField.name + ' created successfully.';
        }
        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create custom fields.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
